// extracted by mini-css-extract-plugin
export default {"more":"styles_more__+bLHs","main":"styles_main__AqUmq","list":"styles_list__ug+au","list__item":"styles_list__item__pcPEM"};